export const FAQList: string[] = [
  'faqQuestion1',
  'faqQuestion2',
  'faqQuestion3',
  'faqQuestion4',
  'faqQuestion5',
  'faqQuestion6',
  'faqQuestion7',
];
